import en_US from '../../date-picker/locale/en_US';
export default en_US;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/calendar/locale/en_US.js
// module id = 273
// module chunks = 1